import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { getYouTubeId } from '../../../utils/contentProcessor';

/**
 * YouTubeEmbed - Organism
 * Player simples com iframe direto.
 *
 * A versao anterior usava react-youtube, que inicializa a IFrame API e pode
 * remontar o player antes de estabilizar. O iframe direto segue o mesmo padrao
 * usado em CardsTestingPage e carrega de forma mais limpa no modal.
 */
const YouTubeEmbed = ({ article, sx = {}, variant = 'embed' }) => {
  const youtubeId = useMemo(
    () => article?.videoId || article?.youtubeId || getYouTubeId(article?.videoUrl || article?.siteUrl),
    [article?.videoId, article?.youtubeId, article?.videoUrl, article?.siteUrl]
  );

  if (!youtubeId || article?.mediaType !== 'YouTube') {
    return null;
  }

  const isModalPlayer = variant === 'preview';
  const embedUrl = `https://www.youtube.com/embed/${youtubeId}?rel=0&modestbranding=1`;

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        aspectRatio: '16 / 9',
        overflow: 'hidden',
        bgcolor: '#030712',
        borderRadius: isModalPlayer ? { xs: '18px', md: '22px' } : '12px',
        border: isModalPlayer ? '1px solid rgba(255,255,255,0.12)' : '1px solid',
        borderColor: isModalPlayer ? 'rgba(255,255,255,0.12)' : 'divider',
        boxShadow: isModalPlayer ? '0 18px 48px rgba(0,0,0,0.28)' : 'none',
        lineHeight: 0,
        mb: 2,
        ...sx
      }}
    >
      <Box
        component="iframe"
        src={embedUrl}
        title={article?.title || 'Video do YouTube'}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          border: 0,
          display: 'block'
        }}
      />
    </Box>
  );
};

YouTubeEmbed.propTypes = {
  article: PropTypes.object,
  sx: PropTypes.object,
  variant: PropTypes.oneOf(['embed', 'preview'])
};

export default YouTubeEmbed;
